/* global ol */

var deliveredIcon = '<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M3.197 5.814L.893 3.51l-.768.768L3.197 7.35 9.78.768 9.01 0 3.198 5.814z" fill="white" />' +
  '</svg>';

var deviationIcon = '<svg width="7" height="8" viewBox="0 0 7 8" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M4.12 4L6.87 1.247a.437.437 0 1 0-.62-.62L3.5 3.382.747.63a.438.438 0 1 0-.62.62L2.882 4 .13 6.753a.437.437 0 1 0 .62.62L3.5 4.618 6.253 7.37a.436.436 0 0 0 .62 0 .437.437 0 0 0 0-.62L4.118 4z" fill="white" />' +
  '</svg>';

var icons = {
  delivered: deliveredIcon,
  deviation: deviationIcon
};

function Style() {
  this.iconCache = {};
  this.textCache = {};
}

Style.prototype.circleStyle = function(coordinates, resolution, radius, color, highlight) {
  var stroke = null;

  if(highlight){
    stroke = new ol.style.Stroke({
      color: 'white',
      width: 5
    });
  }

  return new ol.style.Style({
    geometry: new ol.geom.Circle(coordinates, resolution * radius),
    fill: new ol.style.Fill({
      color: color
    }),
    stroke: stroke
  });
};

Style.prototype.iconStyle = function(icon, scale) {
  if (! this.iconCache[icon]) {
    this.iconCache[icon] = new ol.style.Style({
      image: new ol.style.Icon({
        scale: scale || 1,
        src: 'data:image/svg+xml;charset=UTF-8;base64,' + window.btoa([icons[icon]])
      })
    });
  }

  return this.iconCache[icon];
};

Style.prototype.textStyle = function(text) {
  if (! this.textCache[text]) {
    this.textCache[text] = new ol.style.Style({
      text: new ol.style.Text({
        text: text,
        font: '12px DIN-Regular',
        offsetY: 1,
        fill: new ol.style.Fill({
          color: 'white'
        })
      })
    });
  }

  return this.textCache[text];
};

// options.radius [required]
// options.color [required]
// options.delivered [boolean]
// options.deviation [boolean
// options.text
Style.prototype.circle = function(options, feature, resolution) {
  if (feature && feature.getGeometry()) {
    var coordinates = feature.getGeometry().getCoordinates();
    var circle = this.circleStyle(coordinates, resolution, options.radius, options.color, options.highlight);
    var icon;
    var text;

    if (options.deviation) {
      icon = this.iconStyle('deviation');
    } else if (options.delivered) {
      icon = this.iconStyle('delivered');
    } else if (options.text) {
      text = this.textStyle(options.text);
      if (/^\d+$/.test(options.text)) {
        circle.setZIndex(options.text);
        text.setZIndex(options.text);
      }
    }

    if (icon) return [circle, icon];
    if (text) return [circle, text];
    return circle;
  } else {
    console.log('circle - Missing important args', options, feature, resolution);
  }
};

var style = new Style();

module.exports = style.circle.bind(style);



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/style.js
 ** module id = 13
 ** module chunks = 1
 **/